import React, {ReactNode, useContext, useEffect, useState} from "react";
import {getConfig} from "./ConfigApi";
import {Config} from "./Config";
import {CenteredCircularProgress} from "../../components/progress/CenteredCircularProgress";
import {reportServerVersion} from "../logging/versions";

const CurrentConfigContext = React.createContext<{
  config: Config,
} | undefined>(undefined);

/**
 * Gets current config.
 */
export function useConfig() {
  let configContext = useContext(CurrentConfigContext);
  if (!configContext) {
    throw new Error('No config context available! Probably not called inside CurrentConfigContext.Provider')
  }
  return configContext.config;
}

export function ConfigProvider(props: {
  children: ReactNode
}) {
  const [config, setConfig] = useState<Config>();

  useEffect(() => {
    getConfig().then(config => {
      reportServerVersion(config.gitTag, config.gitCommit);
      setConfig(config);
    });
  }, []);

  if (!config) {
    return <CenteredCircularProgress />;
  }

  return (
    <CurrentConfigContext.Provider value={{config}}>
      {props.children}
    </CurrentConfigContext.Provider>
  );
}
